import { Order, ReturnRequest } from '@/app/shared/interface/order.interface';
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-return-order-list-modal',
  templateUrl: './return-order-list-modal.component.html',
  styleUrl: './return-order-list-modal.component.scss'
})
export class ReturnOrderListModalComponent {
  public order: Order | undefined;
  public returnOrders: ReturnRequest[] = [];
  @ViewChild('returnOrderListModal', { static: false }) thisModal: TemplateRef<string>;

  constructor(
    private modalService: NgbModal,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {

  }

  openModal(order: Order, listData: ReturnRequest[]) {
    if (isPlatformBrowser(this.platformId)) {
      this.order = order;
      this.returnOrders = listData;
      this.modalService.open(this.thisModal, {
        ariaLabelledBy: 'return-order-list-Modal',
        centered: true,
        windowClass: 'theme-modal  modal-xl',
      });
    }
  }

  close() {
    this.modalService.dismissAll();
  }

  ngOnDestroy() {
    this.modalService.dismissAll();
  }
}
